// Client wrappers for /api/meals/vote. Player_id derived server-side
// from the session cookie — never trust the client to claim one.

const TRIP_DEFAULT = 'juneau-2026';

async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${url} → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

async function getJson(url) {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`${url} → ${res.status}`);
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('json')) {
    const err = new Error('api_unavailable');
    err.status = 'api_unavailable';
    throw err;
  }
  return res.json();
}

export async function fetchMealVotes({ tripId = TRIP_DEFAULT } = {}) {
  return getJson(`/api/meals/vote?trip_id=${tripId}`);
}

export async function setMealVote({ tripId = TRIP_DEFAULT, slotId, optionId }) {
  return postJson('/api/meals/vote', {
    trip_id: tripId,
    slot_id: slotId,
    option_id: optionId,
  });
}

export async function resolveMealSlot({ tripId = TRIP_DEFAULT, slotId, optionId }) {
  return postJson('/api/meals/vote', {
    trip_id: tripId,
    slot_id: slotId,
    resolve: optionId,
  });
}
